import { render, staticRenderFns } from "./OrdersIndex.vue?vue&type=template&id=4838d885&"
import script from "./OrdersIndex.vue?vue&type=script&lang=js&"
export * from "./OrdersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports